import React from "react";
import SideBarSkeleton from "../../../Component/SideBarSkeleton";
import VideoTumbnail from "../../../Component/VideoTumbnail";
import classes from "./Step2.module.css";
const index = (props) => {
  return (
    <div className={classes.videoPlayer_div}>
      {/* <video autoplay src={props?.isFile} controls></video> */}
      <div>
        <h3>Video</h3>
        <VideoTumbnail
        thumbnailPicture={props.thumbnailPicture}
          video={props?.videFile}
          setThumbnailPicture={props.setThumbnailPicture}
        />
      </div>
    </div>
  );
};

export default index;
